import { MouseEvent } from 'react';

import copy from 'copy-to-clipboard';

import { EntityAction, EntityActions, notify } from '@cast/design-system';
import { Cluster } from '@cast/types';

type ClusterRowActionsProps = {
  cluster: Cluster;
  onNavigate: (clusterId: string, event: MouseEvent) => void;
};

export const ClusterRowActions = ({
  cluster,
  onNavigate,
}: ClusterRowActionsProps) => {
  const canNavigate = !!cluster.id;
  const canCopyId = !!cluster.id;

  if (!canNavigate && !canCopyId) {
    return null;
  }

  return (
    <EntityActions testId="cluster-row-actions">
      {canNavigate ? (
        <EntityAction
          testId="cluster-row-actions-view"
          onClick={(event) => {
            onNavigate(cluster.id, event);
          }}
        >
          View cluster
        </EntityAction>
      ) : null}
      {canCopyId ? (
        <EntityAction
          testId="cluster-row-actions-copy-id"
          onClick={(event) => {
            event.stopPropagation();
            copy(cluster.id);
            notify.success('Copied to clipboard', { key: 'copy-cluster-id' });
          }}
        >
          Copy cluster ID
        </EntityAction>
      ) : null}
    </EntityActions>
  );
};
